export default __webpack_public_path__ + "static/media/i225hp.5a4880a2.webp";